// Mirrors aws-lambda/shared/validate.mjs -> ABILITY_LEVELS. Keep both in sync.
export const ABILITY_LEVELS = ["Beginner", "Intermediate", "Advanced", "Expert"];
